import { urlBaseAccreditation } from "../../config";
import axiosInstance from "../../../services/config/axiosinstance";

export default async function savePlusXMiceId(
  userEmail = '',
  plusId = '',
  miceId = '',
  active = false,
) {
  try {
    const _config = {
      method: 'POST',
      url: `${urlBaseAccreditation}/plusXMiceId/savePlusXMiceId`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userEmail: userEmail,
        plusId: plusId,
        miceId: miceId,
        active: active,
      }
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return null;
  } catch (error) {
    console.log('Error saveConfig', error);
    throw error;
  }
}
